import React, { Component, Fragment } from "react"
import { connect } from "react-redux"
import { compose } from "recompose"
import {
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  withMobileDialog,
  CardContent,
} from "@material-ui/core"
// import LoadingButton from "../../components/LoadingButton"
// import Grid from "@material-ui/core/Grid"
// import Button from "@material-ui/core/Button"
import styles from "./styles"
import Button from "@material-ui/core/Button"
import { withStyles } from "@material-ui/core/styles"
import { Elements } from "@stripe/react-stripe-js"
import CardForm from "./cardForm"
import { endSubscription } from "../../actions/subscribe"
import { openSnackBar } from "../../actions/snack-bar"
import { _updateUser } from "../../actions/users"
import { loadStripe } from "@stripe/stripe-js"
import { ElementsConsumer } from "@stripe/react-stripe-js"

// import {
//   togglePaymentModal,
//   createBooking,
//   sendBooking
// } from '../../actions/companies'
// import update from 'immutability-helper'
// import InputLabel from '@material-ui/core/InputLabel'
// import Input from '@material-ui/core/Input'
// import FormControl from '@material-ui/core/FormControl'
// import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider'
// import MomentUtils from 'material-ui-pickers/utils/moment-utils'
// import moment from 'moment'
// import { openSnackBar } from '../../actions/snack-bar'

class CancelSubscriptionModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      cancel: {
        page: 0,
        plan: null,
        loading: false,
      },
      equipmentAmt: 0,
      locationAmt: 0,
      roleAmt: 0,
      vehicleAmt: 0,
      tab: 0,
    }
  }
  stripeKey = process.env.REACT_APP_STRIPE_TEST
  // const stripeKey = "pk_live_ePZL8ZYpTh9lmXVWdJGGWq9h00Dy6CzZUL"
  stripePromise = loadStripe(this.stripeKey)
  handleClose = () => {
    this.props.dispatch({
      type: "CANCEL_SUBSCRIPTION_MODAL",
      payload: { open: false, user: {} },
    })
  }

  cancel = () => {
    this.props
      .dispatch(endSubscription(this.props.authenticatedUser.id))
      .then(() => {
        this.handleClose()
        this.props.dispatch(
          openSnackBar({ message: "You have been unscubscribed" })
        )
        this.props.dispatch(
          _updateUser({
            id: this.props.authenticatedUser.id,
            hasMembership: false,
            membershipValid: true,
          })
        )
      })
  }

  handleChange = (e, tab) => {
    this.setState({ tab })
  }

  setProps = () => {
    this.setState({
      equipmentAmt: this.props.user.equipment.length,
      locationAmt: this.props.user.locations.length,
      roleAmt: this.props.user.roles.length,
      vehicleAmt: this.props.user.vehicles.length,
    })
  }

  componentDidUpdate = prevProps => {
    if (prevProps.user.id !== this.props.user.id && this.props.user.id) {
      this.setProps()
    }
  }

  render() {
    const { fullScreen, classes } = this.props
    const {
      cancel,
      locationAmt,
      roleAmt,
      equipmentAmt,
      vehicleAmt,
    } = this.state
    return (
      <Fragment>
        <Elements stripe={this.stripePromise}>
          <ElementsConsumer>
            {({ stripe, elements }) => (
              <Dialog
                fullScreen={fullScreen}
                open={this.props.open}
                onClose={this.handleClose}
                onExited={this.clearState}
                aria-labelledby="responsive-dialog-title"
              >
                <DialogContent open={true}>
                  <Typography className={classes.pModalHeader} variant="h5">
                    Cancel Subscription
                  </Typography>
                  <Typography
                    style={{ color: "red", paddingTop: "15px" }}
                    className={classes.pModal}
                  >
                    If you cancel now you will lose{" "}
                    {locationAmt > 2 ? `${locationAmt - 2} cities, ` : ""}
                    {roleAmt > 2 ? `${roleAmt - 2} roles, ` : ""}
                    {equipmentAmt > 4 ? `${equipmentAmt - 4} equipment, ` : ""}
                    {vehicleAmt > 1 ? `${vehicleAmt - 1} vehicles, ` : ""}Reel,
                    and Clients.
                  </Typography>
                </DialogContent>
                {cancel.page === 0 ? (
                  <DialogContent style={{ overflow: "visible" }}>
                    <div style={{ textAlign: "center" }}>
                      {/* <AppBar position="static" color="default"> */}

                      <Typography variant="h5" className={classes.pModal2}>
                        Are you sure you want to cancel?
                      </Typography>
                    </div>
                  </DialogContent>
                ) : (
                  <CardContent>
                    <CardForm onRef={ref => (this.cardRef = ref)} />
                  </CardContent>
                )}
                <DialogActions>
                  <Button
                    color="primary"
                    onClick={() => {
                      this.handleClose()
                    }}
                  >
                    Nevermind
                  </Button>
                  <Button
                    color="secondary"
                    variant="contained"
                    onClick={this.cancel}
                  >
                    Cancel Subscription
                  </Button>
                </DialogActions>
              </Dialog>
            )}
          </ElementsConsumer>
        </Elements>
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    authenticatedUser: state.authentication.authenticatedUser,
    open: state.cancelSubscriptionModalOpen.open,
    user: state.cancelSubscriptionModalOpen.user,
  }
}

export default compose(
  connect(mapStateToProps),
  withMobileDialog(),
  withStyles(styles, { withTheme: true })
)(CancelSubscriptionModal)
